// Effective withholding tax profile for an AccountingClient
// (docs/WHT_IMPLEMENTATION.md §2). There is no data migration: older clients
// have no whtProfile stored, so every reader goes through getWhtProfile and
// gets the schema defaults plus one read-time fallback:
//
//   hasEmployees = whtProfile.hasEmployees ?? taxObligations.withholdingTaxCompensation ?? false
//
// The backend schema deliberately has no default for hasEmployees, so an
// unanswered value arrives here as undefined and the fallback applies.

export const WHT_PROFILE_DEFAULTS = {
  taxpayerSize: null,
  isTopWithholdingAgent: false,
  agentCategory: 'private',
  isEfps: false,
  isLargeTaxpayer: false,
};

/**
 * Resolve a client's WHT profile. Use this — never read client.whtProfile
 * directly — wherever the UI decides what applies (e.g. whether 1601-C shows).
 */
export function getWhtProfile(client) {
  const stored = client?.whtProfile || {};
  return {
    taxpayerSize: stored.taxpayerSize ?? WHT_PROFILE_DEFAULTS.taxpayerSize,
    isTopWithholdingAgent: stored.isTopWithholdingAgent ?? WHT_PROFILE_DEFAULTS.isTopWithholdingAgent,
    agentCategory: stored.agentCategory ?? WHT_PROFILE_DEFAULTS.agentCategory,
    isEfps: stored.isEfps ?? WHT_PROFILE_DEFAULTS.isEfps,
    isLargeTaxpayer: stored.isLargeTaxpayer ?? WHT_PROFILE_DEFAULTS.isLargeTaxpayer,
    hasEmployees: stored.hasEmployees ?? client?.taxObligations?.withholdingTaxCompensation ?? false,
  };
}
